import { Fragment, useEffect, useRef } from "react";
import {
  Alert,
  Button,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Input,
  InputGroup,
  Label,
  Row,
  UncontrolledAlert,
} from "../../components/Common/AppOverlay";
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  FormGroup,
} from "../../components/Common/AppOverlay";
import { useState } from "react";
import React from "react";
import {
  getCompanyDesignations,
  getuserById,
  getLoggedInUser,
} from "../../helpers/backend_helper";
import { SuccessNotify, ErrorNotify } from "../../shared/Alert";
import { showLoading } from "react-global-loading";
import DesignationDetail from "./DesignationDetail";
import {
  ColumnDirective,
  ColumnsDirective,
  GridComponent,
  Page,
  Inject,
  Toolbar,
  ColumnMenu,
  Filter,
  Sort,
  ExcelExport,
  PdfExport,
  Resize,
} from "../../components/Common/LegacyGridAdapter";

const SettingsDesignation = (props) => {
  let gridInstance;
  const [companyId, setCompanyId] = useState();
  const [groupList, setGroupList] = useState();
  const [canvasOpen, setCanvasOpen] = useState(false);
  const [detailId, setDetailId] = useState(0);

  const toggleCanvasEnd = () => {
    setCanvasOpen(!canvasOpen);
  };

  useEffect(() => {
    setCompanyId(getLoggedInUser().companyId);

    loadData();
  }, []);

  const loadData = () => {
    showLoading(true);

    getCompanyDesignations()
      .then((res) => {
        showLoading(false);

        if (res.status === true) {
          setGroupList(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
        showLoading(false);
        ErrorNotify("Error occured while fetching data");
      });
  };

  const toolbarOptions = [
    "Search",
    { text: "Refresh", prefixIcon: "e-refresh ", id: "refresh" },
  ];

  const viewDetail = (data) => {
    setDetailId(data.id);
    toggleCanvasEnd();
  };

  const headerLink = (props) => {
    return (
      <button
        onClick={() => viewDetail(props)}
        color="primary"
        className="btn btn-link btn-sm waves-effect waves-light"
      >
        {props.name}
      </button>
    );
  };

  const statusTemplate = (props) => {
    return (
      <div>
        {props.status === 1 ? (
          <div className="statustemp e-activecolor">
            <span className="statustxt e-activecolor">Active</span>
          </div>
        ) : (
          <div className="statustemp e-inactivecolor">
            <span className="statustxt e-inactivecolor">Inactive</span>
          </div>
        )}
      </div>
    );
  };

  function toolbarClick(args) {
    switch (args.item.id) {
      case "pdf":
        gridInstance.pdfExport();
        break;
      case "excel":
        gridInstance.excelExport();
        break;
      case "csv":
        gridInstance.csvExport();
        break;
      case "refresh":
        loadData();
        break;
    }
  }

  const onDetailClose = () => {
    setDetailId(0);
    toggleCanvasEnd();
    loadData();
  };

  return (
    <React.Fragment>
      <div className="d-flex flex-row-reverse">
        <Button
          type="button"
          className="btn btn-success waves-effect waves-light"
          to="#"
          onClick={toggleCanvasEnd}
          color="success"
        >
          <i className="bx bx-plus font-size-16 align-middle me-2"></i> Create
          Designation
        </Button>
      </div>

      <div className="mt-2">
        {props.companyId ? (
          <GridComponent
            dataSource={groupList}
            ref={(grid) => (gridInstance = grid)}
            allowPaging={true}
            allowFiltering={true}
            showColumnMenu={true}
            allowResizing={true}
            toolbar={toolbarOptions}
            toolbarClick={toolbarClick.bind(this)}
            statelessTemplates={["directiveTemplates"]}
            allowExcelExport={true}
            allowPdfExport={true}
            pageSettings={{ pageCount: 25, pageSizes: true }}
            filterSettings={{ type: "Excel" }}
          >
            <ColumnsDirective>
              <ColumnDirective
                field="companyProfile.name"
                headerText="Department"
                width="100"
              />
              <ColumnDirective
                field="name"
                headerText="Name"
                template={headerLink}
                width="150"
              ></ColumnDirective>
              <ColumnDirective field="description" headerText="Description" />
              <ColumnDirective
                field="roleInfo.name"
                headerText="Role"
                width="100"
              />
              <ColumnDirective
                field="status"
                template={statusTemplate}
                headerText="Status"
                width="80"
              />
              <ColumnDirective
                field="updatedOn"
                type="date"
                format="dd/MM/yyyy h:mm a"
                headerText="Last Updated"
                width="80"
              />
            </ColumnsDirective>
            <Inject
              services={[
                Toolbar,
                Page,
                Filter,
                ExcelExport,
                Sort,
                PdfExport,
                ColumnMenu,
                Resize,
              ]}
            />
          </GridComponent>
        ) : (
          <GridComponent
            dataSource={groupList}
            ref={(grid) => (gridInstance = grid)}
            allowPaging={true}
            allowFiltering={true}
            showColumnMenu={true}
            allowResizing={true}
            toolbar={toolbarOptions}
            toolbarClick={toolbarClick.bind(this)}
            statelessTemplates={["directiveTemplates"]}
            allowExcelExport={true}
            allowPdfExport={true}
            pageSettings={{ pageCount: 25, pageSizes: true }}
            filterSettings={{ type: "Excel" }}
          >
            <ColumnsDirective>
              <ColumnDirective
                field="name"
                headerText="Name"
                template={headerLink}
                width="150"
              ></ColumnDirective>
              <ColumnDirective field="description" headerText="Description" />
              <ColumnDirective
                field="roleInfo.name"
                headerText="Role"
                width="100"
              />
              <ColumnDirective
                field="status"
                template={statusTemplate}
                headerText="Status"
                width="80"
              />
              <ColumnDirective
                field="updatedOn"
                type="date"
                format="dd/MM/yyyy h:mm a"
                headerText="Last Updated"
                width="80"
              />
            </ColumnsDirective>
            <Inject
              services={[
                Toolbar,
                Page,
                Filter,
                ExcelExport,
                Sort,
                PdfExport,
                ColumnMenu,
                Resize,
              ]}
            />
          </GridComponent>
        )}

        <Offcanvas
          backdrop="static"
          className="w-30"
          direction="end"
          isOpen={canvasOpen}
          toggle={toggleCanvasEnd}
        >
          <OffcanvasHeader toggle={toggleCanvasEnd} className="canvasHeader">
            Designation Detail
          </OffcanvasHeader>
          <OffcanvasBody>
            <DesignationDetail dataId={detailId} closeAction={onDetailClose} />
          </OffcanvasBody>
        </Offcanvas>
      </div>
    </React.Fragment>
  );
};

export default SettingsDesignation;
